import * as ClipboardJS from 'clipboard'

document.addEventListener('turbolinks:load', () => {
  new ClipboardJS('.js-copy').on('success', e => {
    e.trigger.innerHTML = 'Copied!'
    e.clearSelection()
  })

  document.addEventListener('.js-copy', event => {
    event.preventDefault()
  })
})
